import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { mediaQueries, mediaQueriesPx } from '../components/Themes'
import { DarkTheme } from '../components/Themes'

const Logo = styled.h1`
	display: inline-block;
	color: ${(props) => (props.color === 'dark' ? '#d89216' : DarkTheme.body)};
	font-family: 'Pacifico', cursive;
	position: fixed;
	left: 2rem;
	top: 2rem;
	z-index: 3;

	& > *:first-child {
		text-decoration: none;
		color: inherit;
	}
	${mediaQueriesPx(400)`     
		font-size: 1em;
  `}
	${mediaQueries(50)`
	left: 1rem;
  `}
`

const LogoComponent = (props) => {
	return (
		<Logo color={props.theme}>
			<NavLink to="/">
				{document.body.scrollWidth > 570 ? 'Home' : 'HM'}
			</NavLink>
		</Logo>
	)
}

export default LogoComponent
